export const property = {
    gamefi: "Eğlenceli Tahmin Hesabı",
    mc_official_verify_unofficial: "Resmi Olmayan Doğrulama Kanalları",
    mc_official_verify_official: "Resmi",
    mc_official_verify_fotter_tip_1: "Biking resmi çalışanı kisvesiyle ağ/telefon dolandırıcılığına karşı korunma hakkında risk uyarısı",
    mc_official_verify_fotter_tip_2: "\"Biking\" adının kötüye kullanılması ve dolandırıcılık yapılmasına karşı resmi uyarı ve risk bildirimi",
    mc_official_verify_modal_tip_1: "Sorguladığınız 【{query}】, Biking'in resmi kanalı olarak doğrulanmıştır",
    mc_official_verify_modal_tip_3: "Lütfen girdiğiniz bilgi ve formatın doğru olduğunu teyit edin:",
    mc_official_verify_modal_tip_4: "Telefon numarası: xx-xxxxxxxxx",
    mc_official_verify_modal_type_email: "E-posta",
    mc_official_verify_modal_type_domain: "Web sitesi",
    mc_official_verify_modal_type_channel: "Kanal",
    mc_official_verify_input_placeholder: "Lütfen doğrulama için doğru bilgi ve formatı girin",
    mc_official_verify_head_title: "Biking Borsası Resmi Doğrulama Kanalı | Biking Borsası",
    mc_official_verify_head_description: "Biking Borsası Resmi Doğrulama Kanalı",
    mc_official_verify_title: "Resmi Doğrulama Kanalı",
    mc_official_verify_discription_new: "Oltalama ve çevrimiçi dolandırıcılıktan kaynaklanan varlık kayıplarını önlemek için, web sitesi, e-posta adresi, telefon numarası veya Twitter, Telegram gibi sosyal medya hesaplarının Biking'in resmi onaylı kanalı olup olmadığını bu sayfadan doğrulayabilirsiniz.",
    mc_official_verify_fotter_tip_3: "Biking kullanıcıları için zorunlu okuma: Dolandırıcılık önleme kılavuzu, dolandırıcılık yöntemlerindeki gelişmelere dikkat!",
    mc_unofficial_verify_modal_tip_1: "Sorguladığınız 【{query}】, Biking'in resmi kanalı değildir",
    mc_official_verify_discription: "Kötü niyetli kişilerin Biking Global adını kullanarak dolandırıcılık yapmasını önlemek için, sizinle iletişime geçen telefon, WeChat vb. kanalların Biking'in resmi kanalı olup olmadığını bu sayfa üzerinden teyit edebilirsiniz",
    mc_official_head_title1: "Biking Resmi Kanallarını, Haberlerini ve Yayınlarını Doğrulayın",
    mc_official_head_keywords1: "Biking doğrulama, Biking haberleri, Biking resmi hesapları",
    mc_official_head_description1: "Biking kanallarının gerçekliğini sağlayın. Biking ile ilgili kanalların, haberlerin ve yayınların meşruiyetini teyit etmek için resmi doğrulama aracımızı kullanın.",
    mc_official_verify_verified_title: "Resmi Onaylı Kanallar",
    mc_official_verify_modal_tip_5: "Telegram/X/Facebook/Youtube: @xxxxx (@ sembolü ile)",
    mc_official_verify_modal_tip_6: "TikTok/Instagram: xxxx (@ sembolü olmadan)",
    mc_official_verify_modal_tip_7: "Discord: xxxx#xxxx (@ sembolü olmadan)",
    mc_official_verify_modal_tip_8: "Linkedin/Telegram grubu/Medium/Reddit: https://xxxxx (web sitesi bağlantısı)",
    mc_official_verify_modal_tip_9: "Bilgi formatı hakkında sorunuz varsa, lütfen çevrimiçi müşteri hizmetleriyle iletişime geçin.",
    mc_official_verify_modal_tip_10: "*Lütfen hesap bilgilerinizi ve şifrenizi hiç kimseyle paylaşmayın.",
    mc_official_verify_modal_tip_11: "*Dolandırıcılığa karşı dikkatli olun, işlemlerinizi özenle yapın.",
    tagtip: "Para yatırma platformu Comment (açıklama) girmeyi gerektirmiyorsa, bu alan boş bırakılabilir",
    tag: "Lütfen Comment girin",
    qbcbcg: "Para yatırmanın başarılı olması için lütfen hem TON adresini hem de comment'i aynı anda kopyalayın",
    qsrzqje: "Lütfen doğru miktarı girin",
    games: "Oyun Hesabı",
    cbxz: "Ethereum(ERC20) Para Yatırma Bilgileri",
    tbxz: "Ethereum(ERC20) Para Çekme Bilgileri",
    ctbzysx: "Lütfen unutmayın, her FUFU resmi akıllı kontrat transferi %2 ek ücret kesintisine tabidir.",
    dzcw: "Adres Hatalı",
    czqkqrs: "Para Yatırma Blok Onay Sayısı",
    mc: "İsim",
    cjsj: "Oluşturulma Zamanı",
    lx: "Tür",
    sl: "Miktar",
    cwjl: "Mali Kayıtlar",

    ylzh: "Kâr",
    ddtx: "Para Çekme Bekleniyor",
    txcg: "Para Çekme Başarılı",
    yhcx: "Kullanıcı İptal Etti",
    qbcbjl: "Tüm Para Yatırma Kayıtları",

    zczl: "Varlık Özeti",
    zjzh: "Fon Hesabı",
    mbzh: "Coin Satın Alma Hesabı",
    xhzh: "Spot Hesap",
    hyzh: "Kontrat Hesabı",
    lczh: "Finansman Hesabı",
    gdzh: "Kopya Hesabı",
    giftzh: "Bonus Hesabı",
    bwzh: "Biking Kart",
    mozh: "Simülasyon Hesabı",
    mnhy: "Simülasyon Kontrat",
    sxffy: "Sistem Komisyonu",
    kt: "Airdrop",
    xtkc: "Sistem Kesintisi",
    zcfb: "Varlık Dağılımı",
    zcdt: "Varlık Hareketleri",
    zh: "Hesap",
    zc: "Varlık",
    czjl: "Para Yatırma Kaydı",
    txls: "Para Çekme Geçmişi",
    hzjl: "Transfer Kaydı",
    mmjl: "Alım Satım Kaydı",
    cb: "Para Yatır",
    tx: "Para Çek",
    hz: "Transfer",
    mb: "Coin Satın Al",
    jy: "İşlem",
    zwsj: "Henüz Veri Yok",
    ckqb: "Tümünü Görüntüle",

    // table
    bz: "Coin",
    qc: "Tam İsim",
    zhze: "Hesap Toplamı",
    syzc: "Kalan Varlık",
    djzc: "Dondurulmuş Varlık",
    cz: "İşlem",
    sl: "Miktar",
    cbdz: "Para Yatırma Adresi",
    sj: "Zaman",
    zt: "Durum",
    ms: "Açıklama",
    hzfx: "Transfer Yönü",
    hzse: "Transfer Miktarı",
    txdz: "Para Çekme Adresi",
    sxf: "İşlem Ücreti",
    ddh: "Sipariş Numarası",
    zj: "Toplam Fiyat",
    dj: "Birim Fiyat",
    jysl: "İşlem Miktarı",
    jydx: "İşlem Yapılan Taraf",
    zhqy: "Hesap Özkaynağı",
    zhqytips: "Hesap Özkaynağı = Kullanılabilir Teminat + Pozisyon Teminatı",
    kybzj: "Kullanılabilir Teminat",
    kybzjtips: "Pozisyon açmak veya transfer etmek için kullanılabilecek teminat",
    cwbzj: "Pozisyon Teminatı",
    cwbzjtips: "Mevcut pozisyonları sürdürmek için kullanılan teminat",

    // search
    srbz: "Lütfen ilgili coini girin",
    ycxzc: "Küçük Varlıkları Gizle",
    sy: "Tümü",
    qb: "Tümü",
    qx: "Tümünü Seç",
    zhi: "-",
    ksrq: "Başlangıç Tarihi",
    jsrq: "Bitiş Tarihi",
    cx: "Sorgula",
    dc: "Dışa Aktar",
    zjqt: "Son 7 Gün",
    zjygy: "Son 1 Ay",
    qbsj: "Tüm Zamanlar",
    usdt: "USDT",
    ddlx: "Sipariş Türü",
    gm: "Satın Al",
    cs: "Sat",

    // recharge
    czxq: "Para Yatırma Detayları",
    usdtcbjl: "{coinName} Para Yatırma Kaydı",
    cbsl: "Para Yatırma Miktarı",
    cbzt: "Para Yatırma Durumu",
    crdbz: "Lütfen yatırmak istediğiniz coini seçin",
    tqdbz: "Lütfen çekmek istediğiniz coini seçin",
    rmbz: "Popüler Coinler",
    qxz: "Lütfen Seçin",
    cbwl: "Para Yatırma Ağı",
    cbtips: "Lütfen para çekme platformuyla aynı ağı seçtiğinizden emin olun, aksi takdirde varlık kaybı yaşanabilir.",
    txfs: "Para Çekme Yöntemi",
    lstx: "Blokzincir Üzerinden Para Çekme",
    xyb: "Sonraki",
    yxzdq: "Şu an seçili: ",
    dbz: " coin",
    cxxz: "Yeniden Seç",
    dzkbz: "Adres defterinde yeterli adres yok, lütfen yöneticiyle iletişime geçin",
    qxzcrdbz: "Lütfen önce yatırılacak coini seçin",
    qxzcbwl: "Lütfen para yatırma ağını seçin",
    qxztqdbz: "Lütfen önce çekilecek coini seçin",
    cr: "Yatır",
    tq: "Çek",
    cbxq: "Para Yatırma Detayları",
    txxq: "Para Çekme Detayları",
    usdttxjl: "{coinName} Para Çekme Kaydı",
    qbtxjl: "Tüm Para Çekme Kayıtları",
    zyxx: "Önemli Bilgi: Bu adrese sadece {coinName} gönderebilirsiniz, başka bir dijital para gönderirseniz, bu fonu kaybedersiniz.",
    jzjcr: "Fonu Şuraya Yatır:",
    smewm: "QR kodunu tarayın veya aşağıdaki bilgiyi gönderme platformuna kopyalayın",
    xcdzcz: "Bu adrese bu türde olmayan coin yatırmak varlığınızın kurtarılamamasına neden olacaktır",
    znhycz: "Akıllı kontrat yatırma, paket yatırma, blok ödülü yatırma şu anda desteklenmemektedir",
    usdtcbdz: "{coinName} Para Yatırma Adresi",
    fzdz: "Adresi Kopyala",
    usdtdz: "{coinName} Adresi",
    zxcbe: "Minimum Para Yatırma Miktarı",
    zytx2: "Önemli Bilgi: Lütfen alıcı platformun seçtiğiniz {coinName} ağını desteklediğinden emin olun, aksi takdirde bu fonu kaybedersiniz.",
    kytxwl: "{coinName} için Kullanılabilir Para Çekme Ağları",
    xzwl: "Ağ Seç",
    dzym: "{coinName} Adresi",
    srdz: "Adres girin veya adres defterinden seçin",
    jymm: "İşlem Şifresi",
    qsrjymm: "Lütfen işlem şifresini girin",
    zxtbe: "Minimum Para Çekme: {minAmount}",
    ky: "Kullanılabilir: ",
    zhztbxe: "Hesap Toplam Para Çekme Limiti",
    gjxyddj: "Doğrulama seviyenize göre, 24 saat içinde sınırlı miktarda para çekebilirsiniz. Bu limit, seçtiğiniz dijital paraya USD cinsinden dönüştürülerek hesaplanır.",
    scbdjd: "Coin fiyatındaki yüksek oynaklık nedeniyle, bu coinin işlem ücreti değişkendir ve son 24 saatin ortalama coin fiyatına göre, 0.2-0.2 USDT'ye eşdeğer bir işlem ücreti alınır. İşlem ücretini artırarak hesaba geçiş süresini hızlandırabilirsiniz",
    yqdz: "Tahmini Hesaba Geçiş",
    yqdzwf: "Tahmini hesaba geçiş negatif olamaz",
    sfrz: "Kimlik Doğrulama",
    ggyzm: "Google Doğrulama Kodu",
    dxyzm: "SMS Doğrulama Kodu",
    yxyzm: "E-posta Doğrulama Kodu",
    qsryzm: "Lütfen doğrulama kodunu girin",
    fsyzm: "Doğrulama Kodunu Gönder",
    cxfs: "Yeniden Gönder",
    tj: "Gönder",
    qxztxwl: "Lütfen para çekme ağını seçin",
    qsrdz: "Lütfen adresi girin",
    qxzdz: "Lütfen adres seçin",
    qxzyzfs: "Lütfen bir kimlik doğrulama yöntemi seçin",
    qsrtqsl: "Lütfen çekilecek miktarı girin",
    qwcyz: "Lütfen doğrulamayı tamamlayın",
    qqrbdsj: "Lütfen önce telefon numarasının bağlı olup olmadığını kontrol edin",
    qqrbdyx: "Lütfen önce e-posta adresinin bağlı olup olmadığını kontrol edin",
    fzcg: "Kopyalama Başarılı!",
    tbcg: "Para Çekme Başarılı",
    usdttxdz: "{coinName} Para Çekme Adresi",
    lmc: "Ağ İsmi:",
    qtj: "*Lütfen ekleyin: ",
    dz: "Adres",
    fei: "Değil",
    zjds: " adresi varlık kaybına neden olabilir",
    yzfs: "Doğrulama Yöntemi",
    yzm: "Doğrulama Kodu",
    remark: "Açıklama (Comment)",
    qsrremark: "Lütfen açıklama girin (Comment)",
    tjdzcg: "Adres Ekleme Başarılı",
    qxxzyzfs: "Lütfen önce bir doğrulama yöntemi seçin",
    qsrtxdz: "Lütfen para çekme adresini girin",
    stop: "Duraklatıldı",

    // status
    qr0: "0 Onay",
    qr1: "1 Onay",
    dqr: "Onay Bekleniyor",
    czcg: "Para Yatırma Başarılı",
    hzz: "Transfer Devam Ediyor",
    ywc: "Tamamlandı",
    sb: "Başarısız",
    zzcl: "İşleniyor",
    ddsh: "İnceleme Bekleniyor",
    txcg: "Para Çekme Başarılı",
    cxcg: "İptal Başarılı",
    ddtx: "Para Çekme Bekleniyor",
    txsb: "Para Çekme Başarısız",
    slsb: "Blokzincire Kayıt Başarısız",
    dfk: "Ödeme Bekleniyor",
    yfk: "Ödendi",
    yqx: "İptal Edildi",
    ssz: "İtiraz Ediliyor",
    gdfrhz: "Kopya Kâr Payı Transferi",
    hyzh_to_gdzh: "Kontrat Hesabı -> Kopya Hesabı",
    gdzh_to_hyzh: "Kopya Hesabı -> Kontrat Hesabı",
    ddcl: "İşlem Bekleniyor",
    cg: "Başarılı",

    // dialog
    zchz: "Varlık Transferi",
    ljhz: "Hemen Transfer Et",
    cong: "Kimden",
    dao: "Kime",
    qtzh: "Diğer Hesaplar",
    qxzbz: "Lütfen bir coin seçin",
    qsrsl: "Lütfen miktarı girin",
    khz: "Transfer Edilebilir:",
    ye: "Bakiye:",
    hzcg: "Transfer Başarılı",

    // h5
    zcgl: "Varlık Özeti",
    xrzx: "Yeni Gelenlere Özel",
    zzc: "Toplam Varlık",
    jryk: "Günlük Kâr/Zarar",
    zgjz: "3200 USDT Değerinde Yeni Gelen Paketi Sizi Bekliyor",
    zhrj: "Hesabınıza Fon Yatırın",
    xzrjfs: "Fon yatırdıktan sonra dijital para satın alabilirsiniz, durumunuza göre bir fon yatırma yöntemi seçebilirsiniz",
    czszhb: "Dijital Para Yatırma",
    yyydszhb: "Başka platformlarda sahip olduğunuz dijital paraları Biking hesabınıza yatırın.",
    czfb: "Nakit Para Yatırma",
    czzhz: "Sahip olduğunuz yasal para birimlerini Biking hesabınıza yatırın, banka kartı, transfer ve daha birçok ödeme yöntemi desteklenir",
    maibi: "Coin Satın Al",
    tgdsfmb: "Banka kartı, P2P, üçüncü parti yöntemlerle dijital para satın alın",
    yqyl: "Davet ve Hediye",
    yqfy: "Arkadaşlarınızı Davet Edin %20 Komisyon Kazanın",
    cxzzn: "Yeni Başlayan Kılavuzu",
    czzh: "Bir Biking Hesabı Oluşturun",
    hdxrj: "100USDT Yeni Gelen Bonusu Kazanın",
    ck: "Para Yatırma",
    tzndzh: "Hesabınıza yatırım yapın, yolculuğunuza başlayın, çeşitli ödeme yöntemleri desteklenir",
    wcsfrz: "Kimlik Doğrulamasını (KYC) Tamamlayın",
    hgzh: "Kimlik Doğrulamasını (KYC) Tamamlayın ve Uyumlu Hesap Olun",
    ksjy: "İşleme Başlayın",
    tsgd: "Satın, sat veya kopya işlem yap, daha fazlasını keşfet",
    ksndlc: "Yolculuğunuza Başlayın",
    kjydjmhb: "İşlem Yapılabilir Kripto Paralar",
    jmhb: "Kripto paraların toplam değeri 12284.85 milyar ABD Dolarıdır",
    zengjin: "Bonus",
    lc: "Finansman",
    mb: "Coin Satın Al",
    lsjl: "Geçmiş Kayıt",
    zclb: "Varlık Listesi",
    shaixuan: "Filtrele"
};


// WEBPACK FOOTER //
// ./src/i18n/lang/property/tr.js